import React from 'react';

const SubscribeNow = ({ style }) => {
	return (
		<div className="subscribe-now-container text-center">
			<h5 style={style}>
				Subscribe now for exclusive content and recommendations
			</h5>
			<div className="purchase-button">
				<a href={'/accounts'}>
					<p className="purchase-button">SUBSCRIBE NOW</p>
				</a>
			</div>
		</div>
	);
};

export default SubscribeNow;
